module.exports = __webpack_public_path__ + "static/media/infog_mobile.353e1922.svg";